import { ca } from '@cian/analytics';

export function trackBreadcrumbClick(url: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'click_breadcrumbs',
    label: url.split('?')[1] || '',
    useLastProducts: true,
  });
}
